var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("JMTgram")]),_c('p',[_vm._v("존맛탱집을 공유하는 서비스")]),(!_vm.loggedIn)?_c('LoginUser'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }